import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { OFFER_ANCHOR } from './CtaButton';

/** Mobile-only bar: brand · price · button. Hides while the offer box is on screen. */
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    let offerInView = false;
    const update = () => setVisible(window.scrollY > 700 && !offerInView);
    const offer = document.getElementById('offer-cta');
    const observer = offer ? new IntersectionObserver(([entry]) => {
      offerInView = entry.isIntersecting;
      update();
    }) : null;
    if (offer && observer) observer.observe(offer);
    window.addEventListener('scroll', update, {
      passive: true
    });
    update();
    return () => {
      window.removeEventListener('scroll', update);
      observer?.disconnect();
    };
  }, []);
  return <AnimatePresence data-id="element-227" data-mp="3gfirpptama4w">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: reduceMotion ? 0 : 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-charcoal/10 bg-brand-ivory px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 md:hidden" data-id="element-228" data-mp="29igtxp549ryh">
          <div className="flex items-center gap-3" data-id="element-229" data-mp="1qrfxp8vdsaim">
            <p className="min-w-0 flex-1 font-body text-[10px] font-bold uppercase leading-tight tracking-[0.12em] text-brand-charcoal" data-id="element-230" data-mp="1qtaimn6nk2mp">
              Makeup Instructor <span className="text-brand-gold" data-id="element-231" data-mp="1gt03gx124l4w">Ready</span>
            </p>
            <a href={OFFER_ANCHOR} className="rounded-[12px] bg-brand-cta px-5 py-3.5 font-body text-[13px] font-extrabold uppercase tracking-[0.06em] text-brand-cta-text shadow-[0_4px_0_0_#0A6B34] transition-[background-color,transform] duration-150 ease-out active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2" data-id="element-232" data-mp="1gvctlxgyy1t1">
              Get My System
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}